import React from 'react';
import {Element, TooltipContainer, TooltipTitle, TooltipValue} from './ProjectScopingTotals_styled';
import {useProjectTotals} from './ProjectScopingTotalsContext';
import {useIntl} from 'react-intl';

/**
 * Creating Time entries tooltip content
 * @returns JSX element with tooltip content
 */
export const ProjectScopingTotalsTooltips = () => {
	const intl = useIntl();
	const {totalsData} = useProjectTotals();

	return (
		<TooltipContainer>
			<Element split>
				<TooltipTitle>{intl.formatMessage({id: 'project_scoping.tooltip_actual_revenue_on_task'}) + ':'}</TooltipTitle>
				<TooltipValue>{totalsData.actualRevenueForTasks}</TooltipValue>
			</Element>
			<Element split>
				<TooltipTitle>{intl.formatMessage({id: 'project_scoping.tooltip_actual_revenue_on_project'}) + ':'}</TooltipTitle>
				<TooltipValue>{totalsData.actualRevenueForProject}</TooltipValue>
			</Element>
		</TooltipContainer>
	);
};

/**
 * Creating Actual Revenue tooltip content
 * @returns JSX element with tooltip content
 */
export const TimeEntriesValueTooltip = () => {
	const intl = useIntl();
	const {totalsData} = useProjectTotals();

	return (
		<TooltipContainer>
			<Element split>
				<TooltipTitle>{intl.formatMessage({id: 'project_scoping.tooltip_time_entries_on_task'}) + ':'}</TooltipTitle>
				<TooltipValue>{totalsData.timeEntriesOnTasks}</TooltipValue>
			</Element>
			<Element split>
				<TooltipTitle>{intl.formatMessage({id: 'project_scoping.tooltip_time_entries_on_project'}) + ':'}</TooltipTitle>
				<TooltipValue>{totalsData.timeEntriesOnProject}</TooltipValue>
			</Element>
		</TooltipContainer>
	);
};